import { Link, useLocation } from "react-router-dom";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SiteHeader />
      <main className="flex min-h-[80vh] items-center bg-background-50 px-4 pb-20 pt-28">
        <div className="mx-auto w-full max-w-2xl text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className="ri-compass-3-line text-3xl" />
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            这条路线还没有被记录
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            你访问的页面暂时不存在，可能是链接过期或者地址写错了。
            <span className="mx-1 rounded bg-background-200 px-2 py-0.5 font-mono text-xs text-foreground-700">
              {location.pathname}
            </span>
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              回到首页
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看实时热搜榜
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}